<template lang="html">

  <section class="loading column-center">

    <img :src="getLogoColor" class="logo" alt="Dotia">

    <h2 class="title">{{mensajes[pos]}}</h2>

    <svg width="75px"  height="75px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring" style="background: none;"><circle cx="50" cy="50" fill="none" stroke-linecap="round" r="40" stroke-width="6" :stroke="basicColors.basic" stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(77.9105 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>


  </section>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'loading',
    mounted(){
      var that = this;
      let interval = setInterval(function(){
        (that.pos >= that.mensajes.length-1) ? clearInterval(interval) : that.pos++;
      },2000);
    },
    data(){
      return {
        pos : 0,
        mensajes : [
        'Cargando...',
        'Un segundo...',
        'Ya casi está...',
        'Por favor, actualiza el navegador y vuelve a intentarlo'
        ]
      }
    },
    computed : {
      ...mapGetters(['getLogo','getLogoColor','getStyles','basicColors'])
    }
  }
</script>

<style scoped lang="scss">
  .loading {
   min-height: calc(100vh - 120px);
 }

 .logo{
  width: 100%;
  max-width: 200px;
}

.title{
  width: 100%;
  max-width: 200px;
  color: currentColor;
  font-size: 16px;
  font-weight: 300;
  display: inline-block;
  margin-top: 20px;
  margin-bottom: 30px;
}


</style>



// WEBPACK FOOTER //
// src/components/parts/loading.vue